import React, { Component } from "react";
import $ from "jquery";

import YaystackNavBar from "../yaystackNavBar";
import QuestionLine from "../questions/question_line";
import Loader from "../loader";

import { getRecommendation } from "../../helper/recommendation_helper";
import AnswerLine from "../answers/answer_line";
import Hashtag from "../categories/hashtag";
import CommentLine from "../comments/comment_line";
class FullPageComments extends Component {
  state = {
    comments: [],
    current_page: 1,
    total_pages: 1,
    errors: "",
    loaded: false,
    can_load_more: true,
    first_load: true
  };

  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentWillMount() {
    this.getComments(this.state.current_page);
  }

  componentDidUpdate() {
    // Add scroll on first load of did update following an issue with refContainer
    if (this.state.first_load) {
      this.setState({ first_load: false });
      this.refContainer.addEventListener("scroll", this.handleScroll);
    }
  }

  componentWillUnmount() {
    if (this.recommendationCall) {
      this.recommendationCall.cancel();
    }
    this.refContainer.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    const { removeAnswer } = this;
    var answers = this.state.comments.map(function(answer, index) {
      return (
        <AnswerLine
          key={index}
          answer={answer}
          recommendation={true}
          removeAnswer={removeAnswer}
        />
      );
    });
    return (
      <div className="categoryFullPage">
        <YaystackNavBar noLogo={true} />
        <label
          className="yaystack_color yaystack_icon top_left cursor_btn"
          onClick={this.removePageComments}
        >
          <ion-icon name="ios-arrow-back" class="ion-icon" />
        </label>
        <div
          id="comments"
          ref={ref => {
            this.refContainer = ref;
          }}
          className="allow_scroll page_top_nav center"
        >
          <div className="question_row">
            <Hashtag hashtag={this.props.recommendation.hashtag} />
            <QuestionLine
              question={this.props.recommendation}
              showAnswer={false}
            />
          </div>
          <CommentLine
            addAnswer={this.addAnswer}
            recommendation={this.props.recommendation}
          />
          {answers}
          <div className="pb-3" />
          <Loader loaded={this.state.loaded} />
        </div>
      </div>
    );
  }

  addAnswer = answer => {
    const comments = this.state.comments;
    comments.unshift(answer);
    this.setState({
      comments
    });
    this.props.updateCommentsNumber(this.props.recommendation, "add");
  };

  removeAnswer = event => {
    this.props.updateCommentsNumber(this.props.recommendation, "remove");
  };

  handleScroll() {
    if (this.state.can_load_more === false) {
      // Checking if we are not already loading more data
      return;
    }
    if (this.state.current_page >= this.state.total_pages) {
      // We don't check anything if questions doesn't have other questions
      return;
    }
    if (
      $("#comments").scrollTop() + $("#comments").innerHeight() >=
      $("#comments")[0].scrollHeight
    ) {
      // Load More questions
      this.setState({ can_load_more: false });
      const current_page = this.state.current_page + 1;
      this.setState({ current_page });
      this.getComments(this.state.current_page);
    } else {
      // Nothing
    }
  }

  removePageComments = e => {
    this.props.showFullPageComments(null);
  };

  getComments(page) {
    const self = this;
    this.recommendationCall = getRecommendation(
      this.props.recommendation.id,
      page
    );
    this.recommendationCall.promise
      .then(answer => {
        const comments = self.state.comments.concat(answer.comments);
        const errors = answer.errors;
        const loaded = answer.loaded;
        const total_pages = answer.total_pages;
        const can_load_more = true;
        self.setState({ errors, loaded, comments, total_pages, can_load_more });
      })
      .catch(error => {
        const errors = error.errors;
        const loaded = error.loaded;
        const can_load_more = true;
        self.setState({ errors, loaded, can_load_more });
      });
  }
}

export default FullPageComments;



// WEBPACK FOOTER //
// ./src/components/recommendation/full_page_comments.jsx